
import { defineComponent, onMounted, ref } from "vue";
import OwnerService from "@/services/OwnerService";
import router from "@/router";

const ownerService = new OwnerService();

export default defineComponent({
  components: {},
  name: "AccountVerification",
  props: {
    token: String,
  },
  setup(props) {
    console.log("hey oh verifying email with token", props.token);

    const owner = ref({});

    onMounted(async () => {
      const serverResponse = await ownerService.getOwnerByVerificationToken(
        props.token
      );
      console.log("serverResponse", serverResponse);
      if (serverResponse.exists) {
        owner.value = serverResponse.owner;
      } else {
        router.replace("/login");
      }
    });
    return {
      owner,
    };
  },
  methods: {
    async sendForm() {
      console.log("send form", this.token);
      if (this.firstname == "" || this.lastname == "") {
        this.errorMessage = this.$t(
          "errors.accountVerification.formIncomplete"
        );
        // error
      } else {
        this.isFormSending = true;
        await ownerService.verifyAccount(
          this.firstname,
          this.lastname,
          this.headquarters_address,
          this.token
        );
        this.isSuccess = true;
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
    },
  },
  data() {
    return {
      lastname: "",
      firstname: "",
      headquarters_address: "",
      errorMessage: "",
      isFormSending: false,
      isSuccess: false,
    };
  },
});
